import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./ScheduleConsultPage.css";
import ProgressBarsWithArrows from "../ProgressBarsWithArrows/ProgressBarsWithArrows";
import { useNavigate } from "react-router-dom";
import { getTimeSlots } from "../../services/api";
import { useLocation } from "react-router-dom";

type TimeSlot = {
  start: string;
  end: string;
};

const ScheduleConsultPage: React.FC = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  const [timeZone, setTimeZone] = useState<string>("America/Toronto");
  const [timeSlots, setTimeSlots] = useState<TimeSlot[]>([]);
  const [date, setDate] = useState<Date | null>(new Date());
  const [selectedTime, setSelectedTime] = useState<string | null>(null);
  
  // Pagination state
  const [currentPage, setCurrentPage] = useState<number>(0);
  const slotsPerPage = 5; // Number of slots per page

  const handleDateChange = (value: Date | null) => {
    setDate(value);
  };
  const { appointmentId, isReschedule } = location.state || {};
  useEffect(() => {
  }, [appointmentId, isReschedule]);

  const handleTimeSlotClick = (time: string) => {
    setSelectedTime(time);
  };
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // Initialize
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Pagination logic
  const handleNextPage = () => setCurrentPage(currentPage + 1);
  const handlePrevPage = () => setCurrentPage(currentPage - 1);
  const currentSlots = isMobile
    ? timeSlots.slice(currentPage * slotsPerPage, (currentPage + 1) * slotsPerPage)
    : timeSlots;

  const formatDateAndTime = (date: Date, time: string) => {
    const [timePart, ampm] = time.split(' ');
    const [hours, minutes] = timePart.split(':');
    
    const appointmentDate = new Date(date);
    appointmentDate.setHours(ampm === 'PM' ? +hours + 12 : +hours);
    appointmentDate.setMinutes(+minutes);
  
    const formattedTime = `${time} - ${appointmentDate.toLocaleDateString("en-US", {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })}`;
  
    return formattedTime;
  };
  
  const handleNext = () => {
    if (date && selectedTime) {
      navigate("/dashboard/book_appointment", {
        state: { date, time: selectedTime, timeZone,isReschedule,appointmentId },
      });
    } else {
      alert("Please select a date and time before proceeding.");
    }
  };

  const handlePrev = () => {
    navigate("/dashboard")
  }

  // const handlePrev = () => {
  //   if (currentPage > 0) {
  //     setCurrentPage(currentPage - 1);
  //   }
  // };

  // const handleNextPage = () => {
  //   if ((currentPage + 1) * slotsPerPage < timeSlots.length) {
  //     setCurrentPage(currentPage + 1);
  //   }
  // };

  useEffect(() => {
    const getAvailableSlots = async () => {
      try {
        const response = await getTimeSlots();
        setTimeSlots(response || []);
      } catch (err) {
        console.error("Failed to fetch time slots:", err);
      }
    };
  
    getAvailableSlots();
  }, []);

  // const currentSlots = timeSlots.slice(currentPage * slotsPerPage, (currentPage + 1) * slotsPerPage);

  return (
    <div className="schedule-container">
      <h1 className="schedule-heading">Schedule Your Consult</h1>
      <div className="progress-bars">
        <ProgressBarsWithArrows onNext={handleNext} onBack={handlePrev}  />
      </div>
      <p className="select-date-time-text">Choose a date for your appointment</p>

      <div className="time-zone-dropdown">
        <select
          id="timezone"
          name="timezone"
          value={timeZone}
          onChange={(e) => setTimeZone(e.target.value)}
        >
          <option value="America/Toronto">(UTC-4:00) America/Toronto</option>
          <option value="America/New_York">(UTC-5:00) America/New_York</option>
          <option value="Europe/London">(UTC+0:00) Europe/London</option>
          <option value="Asia/Tokyo">(UTC+9:00) Asia/Tokyo</option>
          <option value="Australia/Sydney">(UTC+10:00) Australia/Sydney</option>
        </select>
      </div>

      <div className="calendar-section">
  <div className="calendar">
    <Calendar
      onChange={(value: any) => handleDateChange(value)}
      minDate={new Date()}
      className="custom-calendar"
    />
  </div>
  <div className={`time-slots ${isMobile ? "mobile" : "desktop"}`}>
        {currentSlots.length === 0 ? (
          <p className="no-slots-message">No slots available for the selected date.</p>
        ) : (
          currentSlots.map((slot: any, index: number) => (
            <button
              key={index}
              className={`time-slot ${selectedTime === slot.start ? "selected" : ""}`}
              onClick={() => setSelectedTime(slot.start)}
            >
              {slot.start}
            </button>
          ))
        )}
      </div>
  {/* Pagination buttons */}
  {isMobile && (
        <div className="pagination">
          <button
            className="prev-btn"
            onClick={handlePrevPage}
            disabled={currentPage === 0}
          >
            Prev
          </button>
          <button
            className="next-btn"
            onClick={handleNextPage}
            disabled={(currentPage + 1) * slotsPerPage >= timeSlots.length}
          >
            Next
          </button>
        </div>
      )}
</div>


    </div>
  );
};

export default ScheduleConsultPage;
